import { StarIcon } from '@heroicons/react/24/solid';
import React from 'react';

interface RatingStarsProps {
  setRating?(n: number): void;

  rating: number;
  mode?: 'edit' | 'readonly' | 'review';
  reviews?: number;
}

export const RatingStars = ({
  setRating,
  rating,
  reviews,
  mode = 'readonly',
}: RatingStarsProps) => {
  if (mode === 'review') {
    return (
      <>
        {[1, 2, 3, 4, 5].map((n) => (
          <StarIcon
            key={n}
            className={`w-4 h-4 ${
              rating >= n
                ? 'text-yellow-400'
                : rating >= n - 0.5
                  ? 'text-yellow-300'
                  : 'text-gray-300'
            }`}
          />
        ))}
        <span className="text-sm text-gray-800 ml-2">({reviews})</span>
      </>
    );
  }

  if (mode === 'readonly') {
    return (
      <div className="flex items-center gap-[1px]">
        {[1, 2, 3, 4, 5].map((n) => (
          <StarIcon
            key={n}
            className={`w-4 h-4 ${
              rating >= n ? 'text-yellow-400' : 'text-gray-300'
            }`}
          />
        ))}
      </div>
    );
  }

  return (
    <div className="flex items-center space-x-1">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          onClick={() => setRating?.(n)}
          className={rating >= n ? 'text-yellow-400' : 'text-gray-300'}
        >
          <StarIcon className="w-6 h-6" />
        </button>
      ))}
    </div>
  );
};
